import { Paper, PaperProps } from '@mantine/core';
import { FC } from 'react';

const GrandientPaper: FC<PaperProps> = ({ children, sx, ...rest }) => (
  <Paper
    shadow="xs"
    p={40}
    sx={(theme) => ({
      maxWidth: 480,
      borderRadius: 10,
      position: 'relative',
      backgroundClip: 'padding-box, border-box',
      backgroundImage: `linear-gradient(${
        theme.colorScheme === 'dark' ? theme.colors.dark[8] : '#fff,#fff'
      }),linear-gradient(88deg,#ffba5e,#ff6b69)`,
      borderTop: '10px double transparent',
    })}
    {...rest}
  >
    {children}
  </Paper>
);

export default GrandientPaper;
